const AlphabetNav = () => {
  const setNotActiveLinks = () => {
    const navLinks = document.querySelectorAll('strong[id]')
    const glossarySection = document.querySelectorAll('.alphabet-nav__link')

    const availableGlossarySection = [...navLinks].map((el) => {
      return el.getAttribute('id')
    })

    glossarySection.forEach((el) => {
      const anchor = el.getAttribute('data-anchor')
      if (!availableGlossarySection.includes(anchor)) {
        el.classList.add('alphabet-nav__link--disabled')
      }
    })
  }

  const self = {
    init () {
      setNotActiveLinks()
    }
  }

  return self
}

export default AlphabetNav
